import '@react-pdf-viewer/core/lib/styles/index.css';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton, Paper, Stack, Typography, styled } from '@mui/material';

export const ApproveIconLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
    <path
      d="M43.0312 25.5C43.0312 15.8178 35.1822 7.96875 25.5 7.96875C15.8178 7.96875 7.96875 15.8178 7.96875 25.5C7.96875 35.1822 15.8178 43.0312 25.5 43.0312C35.1822 43.0312 43.0312 35.1822 43.0312 25.5ZM31.0491 20.0879C31.6715 19.4655 32.6803 19.4655 33.3027 20.0879C33.9251 20.7103 33.9251 21.7192 33.3027 22.3416L24.2362 31.4081C23.6138 32.0305 22.6049 32.0305 21.9825 31.4081L18.8926 28.3181C18.2702 27.6957 18.2702 26.6869 18.8926 26.0645C19.515 25.4421 20.5238 25.4421 21.1462 26.0645L23.1094 28.0276L31.0491 20.0879ZM46.2188 25.5C46.2188 36.9426 36.9426 46.2188 25.5 46.2188C14.0574 46.2188 4.78125 36.9426 4.78125 25.5C4.78125 14.0574 14.0574 4.78125 25.5 4.78125C36.9426 4.78125 46.2188 14.0574 46.2188 25.5Z"
      fill="#31B77A"
    />
  </svg>
);

export const RejectIconLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
    <path
      d="M43.0312 25.5C43.0312 15.8178 35.1822 7.96875 25.5 7.96875C15.8178 7.96875 7.96875 15.8178 7.96875 25.5C7.96875 35.1822 15.8178 43.0312 25.5 43.0312C35.1822 43.0312 43.0312 35.1822 43.0312 25.5ZM31.1342 17.6122C31.7566 16.9898 32.7654 16.9898 33.3878 17.6122C34.0102 18.2346 34.0102 19.2434 33.3878 19.8658L27.7537 25.5L33.3878 31.1342C34.0102 31.7566 34.0102 32.7654 33.3878 33.3878C32.7654 34.0102 31.7566 34.0102 31.1342 33.3878L25.5 27.7537L19.8658 33.3878C19.2434 34.0102 18.2346 34.0102 17.6122 33.3878C16.9898 32.7654 16.9898 31.7566 17.6122 31.1342L23.2463 25.5L17.6122 19.8658C16.9898 19.2434 16.9898 18.2346 17.6122 17.6122C18.2346 16.9898 19.2434 16.9898 19.8658 17.6122L25.5 23.2463L31.1342 17.6122ZM46.2188 25.5C46.2188 36.9426 36.9426 46.2188 25.5 46.2188C14.0573 46.2188 4.78125 36.9426 4.78125 25.5C4.78125 14.0573 14.0573 4.78125 25.5 4.78125C36.9426 4.78125 46.2188 14.0573 46.2188 25.5Z"
      fill="#E9554A"
    />
  </svg>
);

export const ModalContainer = styled(Box)<{ $containerWidth?: string }>(
  ({ $containerWidth = '90%' }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    width: $containerWidth,
    height: '90%',
    alignItems: 'flex-start',
    backgroundColor: 'white',
    borderRadius: '1.5rem',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    overflow: 'hidden',
    gap: 0,
    boxSizing: 'border-box',
    outline: 'none',
  }),
);

export const LeftSideContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  gap: 0,
  flex: '1 1 auto',
  minWidth: 0,
  minHeight: 0,
  overflow: 'hidden',
  alignSelf: 'stretch',
  backgroundColor: '#F7F8FC',
}));

export const InnerContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '1.25rem 0.75rem 1.25rem 0.75rem',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '0.75rem',
  flex: '1 1 0',
  width: '100%',
  minWidth: 0,
  minHeight: 0,
  alignSelf: 'stretch',
  position: 'relative',
  overflow: 'hidden',
  '&::after': {
    content: '""',
    position: 'absolute',
    right: '-25px',
    top: 0,
    bottom: 0,
    width: '25px',
    boxShadow: '8px 0 20px 10px rgba(0,0,0,0.1)',
    pointerEvents: 'none',
  },
}));

export const CarouselContainer = styled(Box)(() => ({
  flex: '1 1 auto',
  alignSelf: 'stretch',
  borderRadius: '1rem',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: 0,
  minWidth: 0,
}));

export const NavigationButton = styled(IconButton)(() => ({
  display: 'flex',
  width: '2.75rem',
  height: '2.75rem',
  padding: '0.25rem',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '2.6875rem',
  background: 'var(--Background-1, #FEFEFE)',
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.14)',
}));

export const LeftButton = styled(NavigationButton)(() => ({
  marginRight: '0.75rem',
  '&:hover': {
    transform: 'scale(1.1)',
    transition: 'transform 0.2s ease-in-out',
    background: 'var(--Background-1, #FEFEFE)',
  },
}));

export const RightButton = styled(NavigationButton)(() => ({
  marginLeft: '0.75rem',
  '&:hover': {
    transform: 'scale(1.1)',
    transition: 'transform 0.2s ease-in-out',
    background: 'var(--Background-1, #FEFEFE)',
  },
}));

export const ImageBoxContainer = styled(Box)(() => ({
  flex: '0 1 auto',
  // height: 'auto',
  borderRadius: '1rem',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: '#F7F8FC',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxHeight: '100%',
  maxWidth: '100%',
  width: '100%',
  height: '100%',
}));

export const TitleOverlay = styled(Box)(() => ({
  display: 'inline-flex',
  gap: '0.625rem',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: '8px',
  left: '8px',
  height: '2.25rem',
  backgroundColor: 'rgba(255,255,255, 0.70)',
  borderRadius: '0.75rem',
  boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
  padding: '0 0.8125rem',
  backdropFilter: 'blur(2px)',
  maxWidth: 'calc(100% - 2.5rem)',
  minWidth: '8rem',
}));

export const ControlsOverlay = styled(Stack)<{ $isCompact?: boolean }>(({ $isCompact }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: $isCompact ? '0.25rem' : '0.5rem',
  position: 'absolute',
  left: '50%',
  bottom: '0.75rem',
  transform: 'translateX(-50%)',
  maxWidth: 'calc(100% - 2rem)',
  height: 'auto',
  minHeight: $isCompact ? '2.5rem' : '3.375rem',
  boxSizing: 'border-box',
  borderRadius: '3.125rem',
  border: '1px solid rgba(255, 255, 255, 0.30)',
  backgroundColor: 'rgba(255, 255, 255, 0.80)',
  boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
  backdropFilter: 'blur(2px)',
  paddingTop: $isCompact ? '0.25rem' : '0.35rem',
  paddingBottom: $isCompact ? '0.25rem' : '0.35rem',
  paddingLeft: $isCompact ? '0.75rem' : '1.2rem',
  paddingRight: $isCompact ? '0.75rem' : '1.2rem',
}));

export const RightSideContainer = styled(Box)(() => ({
  display: 'flex',
  padding: '1.125rem 0.5rem 0 0.5rem',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '1.5rem',
  alignSelf: 'stretch',
  backgroundColor: 'white',
  width: '360px',
  flexShrink: 0,
  position: 'relative',
  zIndex: 10,
}));

export const SidebarHeader = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexShrink: 0,
  paddingRight: '0.5rem',
}));

export const CloseButtonContainer = styled(Box)(() => ({
  width: '2.5rem',
  height: '2.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '2097150rem',
  backgroundColor: 'rgba(255, 255, 255, 0.50)',
  boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.20), 0 8px 10px -6px rgba(0, 0, 0, 0.10)',
  transition: 'all 0.1s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.80)',
    '& .MuiButtonBase-root': {
      transform: 'rotate(90deg)',
    },
  },
}));

export const CloseIconButton = styled(IconButton)(() => ({
  width: '100%',
  height: '100%',
  padding: 0,
  transition: 'all 0.1s ease',
  borderRadius: 'inherit',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent',
    transform: 'rotate(90deg)',
  },
}));

export const ErrorBanner = styled(Box)(() => ({
  marginTop: '1rem',
  padding: '0.5rem',
  backgroundColor: '#FEF2F2',
  border: '1px solid #FECACA',
  borderRadius: '0.5rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
}));

export const UploadContainer = styled(Box)(() => ({
  alignSelf: 'flex-end',
  flexShrink: 0,
}));

export const StyledChevronLeft = styled(ChevronLeftIcon)(() => ({
  display: 'flex',
  width: '3.5rem',
  height: '3.5rem',
  padding: '0.625rem 0.6875rem 0.625rem 0.5625rem',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  color: '#504E5A',
}));

export const StyledChevronRight = styled(ChevronRightIcon)(() => ({
  display: 'flex',
  width: '3.5rem',
  height: '3.5rem',
  padding: '0.625rem 0.6875rem 0.625rem 0.5625rem',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  color: '#504E5A',
}));

export const VersionListContainer = styled(Box)(() => ({
  width: '100%',
  flex: '1 1 auto',
  overflowY: 'auto',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
}));

export const VersionSectionContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  width: '100%',
  paddingLeft: '0.5rem',
  paddingRight: '0.5rem',
}));

export const VersionSectionTitle = styled(Box)(() => ({
  color: '#504E5A',
  fontFamily: '"Neue Frutiger World"',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '130%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const VersionCardContainer = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  padding: '0.75rem',
  border: isActive ? `1px solid ${theme.palette.accent.main}` : '1px solid transparent',
  borderRadius: '0.75rem',
  backgroundColor: '#F5F5F7',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  fontFamily: 'Neue Frutiger World',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#EBEBEE',
    borderColor: isActive ? theme.palette.accent.main : 'transparent',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
  },
}));

export const VersionCardThumbnail = styled('img')(() => ({
  width: '40px',
  height: '56px',
  borderRadius: '4px',
  objectFit: 'cover',
  flexShrink: 0,
  backgroundColor: '#E5E7EB',
}));

export const VersionCardThumbnailPlaceholder = styled(Box)(() => ({
  width: '40px',
  height: '56px',
  borderRadius: '4px',
  backgroundColor: '#E5E7EB',
  flexShrink: 0,
}));

export const VersionCardFileName = styled(Typography)({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: '#615E6F',
  lineHeight: 1.3,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const VersionBadge = styled(Box)(() => ({
  backgroundColor: '#8F8EA3',
  color: '#FEFEFE',
  borderRadius: '4px',
  width: '24px',
  height: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '160%',
  flexShrink: 0,
}));

export const UploaderBadgeIcon = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.accent.main,
  color: '#FEFEFE',
  borderRadius: '50%',
  width: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.65rem',
  fontWeight: 500,
  flexShrink: 0,
}));

export const VersionDetailsContainer = styled(Box)({
  marginTop: '1rem',
  // paddingTop: '0.5rem',
  // borderTop: '1px solid #F3F4F6',
  display: 'grid',
  gridTemplateColumns: '1fr 2fr',
  rowGap: '0.5rem',
  fontSize: '0.75rem',
});

export const VersionLabelText = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  color: theme.palette.grey[800],
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
}));

export const VersionValueText = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  color: theme.palette.grey[800],
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
}));

export const RejectionReasonLabel = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  color: theme.palette.grey[800],
}));

export const RejectionReasonText = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  color: theme.palette.grey[800],
  wordBreak: 'break-word',
}));

export const HiddenFileInput = styled('input')(() => ({
  display: 'none',
}));

export const FileNameOverlay = styled(Typography)(() => ({
  color: '#010203',
  fontSize: '0.875rem',
  fontWeight: 500,
}));

export const ControlsBottomContainer = styled(Box)<{ $isCompact?: boolean }>(({ $isCompact }) => ({
  position: 'absolute',
  bottom: '0.75rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: $isCompact ? '0.5rem' : '1rem',
  maxWidth: 'calc(100% - 2rem)',
  boxSizing: 'border-box',
  zIndex: 10,
}));

export const ChatButton = styled(IconButton)<{ $isCompact?: boolean }>(({ $isCompact }) => ({
  width: $isCompact ? '2.5rem' : '3.375rem',
  height: $isCompact ? '2.5rem' : '3.375rem',
  borderRadius: '3.125rem',
  backgroundColor: 'rgba(255, 255, 255, 0.80)',
  border: '1px solid rgba(255, 255, 255, 0.30)',
  boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
  backdropFilter: 'blur(2px)',
  color: '#162755',
  zIndex: 50,
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.80)',
    '& svg': {
      boxShadow: '0 0 0 5px rgba(0, 0, 0, 0.04)',
      borderRadius: '50%',
      display: 'block',
      overflow: 'visible',
    },
  },
}));

export const ControlIconButton = styled(IconButton)(() => ({
  color: '#162755',
  '&:hover': {
    bgcolor: 'rgba(0,0,0,0.04)',
  },
}));

export const DateTimeText = styled(Typography)(() => ({
  fontSize: '0.75rem',
  color: '#615E6F',
}));

export const MoreOptionsButton = styled(IconButton)(() => ({
  color: '#615E6F',
  p: 0,
  minWidth: 'auto',
}));

export const NoVersionsText = styled(Typography)(() => ({
  textAlign: 'center',
  color: '#9CA3AF',
  marginTop: '2rem',
  fontSize: '0.875rem',
}));

export const ErrorMessage = styled(Typography)(() => ({
  color: '#B91C1C',
  fontSize: '0.75rem',
}));

export const GalleryContainer = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '1rem',
  alignItems: 'flex-start',
  padding: '1rem',
  backgroundColor: '#FFF',
  width: '100%',
  minWidth: 0,
  overflow: 'auto',
  boxShadow: '0 -5px 15px 0 rgba(0, 0, 0, 0.12)',
  '&::-webkit-scrollbar': {
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#F3F4F6',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#D1D5DB',
    borderRadius: '3px',
    '&:hover': {
      backgroundColor: '#9CA3AF',
    },
  },
}));

export const AddImageButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '120px',
  width: '120px',
  height: '120px',
  borderRadius: '1rem',
  backgroundColor: theme.palette.grey[100],
  cursor: 'pointer',
  flexShrink: 0,
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
    transform: 'scale(1.05)',
  },
}));

export const ThumbnailImage = styled(Box)<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  minWidth: '120px',
  width: '120px',
  height: '120px',
  borderRadius: '1rem',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  flexShrink: 0,
  cursor: 'pointer',
  backgroundColor: theme.palette.grey[100],
  border: isSelected ? `4px solid ${theme.palette.accent.main}` : '2px solid transparent',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
}));

export const ActionButton = styled('button')<{ $isCompact?: boolean }>(({ $isCompact }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  height: $isCompact ? '2rem' : '2.25rem',
  paddingLeft: $isCompact ? '0.4rem' : '1rem',
  paddingRight: $isCompact ? '0.4rem' : '1rem',
  borderRadius: '9999px',
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  fontSize: '12px',
  fontWeight: 500,
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(0,0,0,0.04)',
  },
}));

export const ApproveButton = styled(ActionButton)(({ theme }) => ({
  color: theme.palette.success.main,
}));

export const RejectButton = styled(ActionButton)(() => ({
  color: '#E9554A',
}));

export const ApproveIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M17.33 5.05L7.5 15.33L2.67 10.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RejectIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M15 5L5 15M5 5L15 15"
      stroke="#E9554A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExpandIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M5.81543 7.88411C6.05945 7.64011 6.45513 7.64023 6.69922 7.88411C6.94329 8.1282 6.9433 8.52383 6.69922 8.7679L2.13379 13.3333H5.45329C5.79829 13.3335 6.07829 13.6133 6.07829 13.9583C6.07829 14.3034 5.79829 14.5831 5.45329 14.5833H0.625C0.279822 14.5833 0 14.3035 0 13.9583V9.13086C0 8.78568 0.279822 8.50586 0.625 8.50586C0.970178 8.50586 1.25 8.78568 1.25 9.13086V12.4495L5.81543 7.88411ZM14.5833 5.45247C14.5833 5.79765 14.3035 6.07747 13.9583 6.07747C13.6132 6.07747 13.3333 5.79765 13.3333 5.45247V2.13379L8.7679 6.69922C8.52388 6.94322 8.1282 6.94311 7.88411 6.69922C7.64004 6.45513 7.64003 6.0595 7.88411 5.81543L12.4495 1.25H9.13005C8.78504 1.24979 8.50505 0.970051 8.50505 0.625C8.50505 0.279949 8.78504 0.0002065 9.13005 0H13.9583C14.3035 0 14.5833 0.279822 14.5833 0.625V5.45247Z"
      fill="black"
    />
  </svg>
);

export const ZoomInCustomIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M15.4414 9.5332C15.4413 6.27018 12.7962 3.625 9.5332 3.625C6.27022 3.62507 3.62507 6.27022 3.625 9.5332C3.625 12.7962 6.27018 15.4413 9.5332 15.4414C12.7963 15.4414 15.4414 12.7963 15.4414 9.5332ZM8.87484 11.9998V10.1248H6.99984C6.65473 10.1247 6.37484 9.84496 6.37484 9.49984C6.37493 9.15479 6.65479 8.87493 6.99984 8.87484H8.87484V6.99984C8.87493 6.65479 9.15479 6.37493 9.49984 6.37484C9.84496 6.37484 10.1247 6.65473 10.1248 6.99984V8.87484H11.9998C12.345 8.87484 12.6247 9.15473 12.6248 9.49984C12.6248 9.84502 12.345 10.1248 11.9998 10.1248H10.1248V11.9998C10.1248 12.345 9.84502 12.6248 9.49984 12.6248C9.15473 12.6247 8.87484 12.345 8.87484 11.9998ZM16.6914 9.5332C16.6914 11.3052 16.0457 12.9251 14.9792 14.1751L17.4344 16.5506C17.6825 16.7906 17.689 17.1863 17.4491 17.4344C17.2091 17.6825 16.8134 17.6891 16.5653 17.4491L14.0897 15.054C12.8518 16.0768 11.2643 16.6914 9.5332 16.6914C5.57982 16.6913 2.375 13.4866 2.375 9.5332C2.37507 5.57987 5.57987 2.37507 9.5332 2.375C13.4866 2.375 16.6913 5.57982 16.6914 9.5332Z"
      fill="black"
    />
  </svg>
);

export const ZoomOutCustomIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M15.4414 9.5332C15.4413 6.27018 12.7962 3.625 9.5332 3.625C6.27022 3.62507 3.62507 6.27022 3.625 9.5332C3.625 12.7962 6.27018 15.4413 9.5332 15.4414C12.7963 15.4414 15.4414 12.7963 15.4414 9.5332ZM11.9998 8.87484C12.345 8.87484 12.6247 9.15473 12.6248 9.49984C12.6248 9.84502 12.345 10.1248 11.9998 10.1248H6.99984C6.65473 10.1247 6.37484 9.84496 6.37484 9.49984C6.37493 9.15479 6.65479 8.87493 6.99984 8.87484H11.9998ZM16.6914 9.5332C16.6914 11.3052 16.0457 12.9251 14.9792 14.1751L17.4344 16.5506C17.6825 16.7906 17.6891 17.1863 17.4491 17.4344C17.2091 17.6825 16.8134 17.6891 16.5653 17.4491L14.0897 15.054C12.8518 16.0768 11.2643 16.6914 9.5332 16.6914C5.57982 16.6913 2.375 13.4866 2.375 9.5332C2.37507 5.57987 5.57987 2.37507 9.5332 2.375C13.4866 2.375 16.6913 5.57982 16.6914 9.5332Z"
      fill="black"
    />
  </svg>
);

export const DownloadCustomIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M16.2296 16.5381C16.4765 16.297 16.8722 16.302 17.1134 16.5487C17.3545 16.7955 17.3503 17.1913 17.1037 17.4325C16.6481 17.8773 16.0327 18.125 15.3947 18.125H4.60529C3.96729 18.125 3.35185 17.8773 2.8963 17.4325C2.64967 17.1913 2.64547 16.7955 2.88654 16.5487C3.12773 16.302 3.52348 16.297 3.77033 16.5381C3.9893 16.7519 4.28938 16.875 4.60529 16.875H15.3947C15.7106 16.875 16.0107 16.7519 16.2296 16.5381ZM9.3758 2.5C9.3758 2.15489 9.6557 1.8751 10.0008 1.875C10.346 1.875 10.6258 2.15482 10.6258 2.5V11.0221L13.6873 8.19092C13.9407 7.95651 14.3359 7.97172 14.5703 8.2251C14.8046 8.47843 14.7893 8.87367 14.5361 9.10807L10.4256 12.911C10.1861 13.1325 9.81637 13.1324 9.57681 12.911L5.46629 9.10807C5.21299 8.87375 5.19714 8.47849 5.4313 8.2251C5.6657 7.97172 6.0617 7.95651 6.31509 8.19092L9.3758 11.0213V2.5Z"
      fill="black"
    />
  </svg>
);

export const DeleteCustomIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M14.3749 6.02946C14.3749 5.87523 14.2782 5.79349 14.1991 5.77555L14.1666 5.7723H5.83325L5.8007 5.77555C5.72164 5.79349 5.62492 5.87523 5.62492 6.02946V15.7357C5.62511 16.3991 6.12457 16.875 6.66659 16.875H13.3333C13.8753 16.875 14.3747 16.3991 14.3749 15.7357V6.02946ZM11.8749 3.38216C11.8748 3.20602 11.7484 3.125 11.6666 3.125H8.33325C8.2514 3.125 8.12501 3.20602 8.12492 3.38216V4.26432C8.12492 4.44059 8.25137 4.5223 8.33325 4.5223H11.6666C11.7485 4.5223 11.8749 4.44059 11.8749 4.26432V3.38216ZM13.1249 4.26432C13.1249 4.35159 13.1164 4.43798 13.1021 4.5223H16.6666C17.0118 4.5223 17.2916 4.80212 17.2916 5.1473C17.2915 5.49237 17.0117 5.7723 16.6666 5.7723H15.6021C15.6164 5.85647 15.6249 5.94236 15.6249 6.02946V15.7357C15.6247 17.0212 14.632 18.125 13.3333 18.125H6.66659C5.36788 18.125 4.37512 17.0212 4.37492 15.7357V6.02946C4.37492 5.94236 4.38347 5.85647 4.39771 5.7723H3.33325C2.98815 5.7723 2.70838 5.49237 2.70825 5.1473C2.70825 4.80212 2.98807 4.5223 3.33325 4.5223H6.8977C6.88342 4.43798 6.87492 4.35159 6.87492 4.26432V3.38216C6.87502 2.58389 7.49473 1.875 8.33325 1.875H11.6666C12.5051 1.875 13.1248 2.58389 13.1249 3.38216V4.26432Z"
      fill="black"
    />
  </svg>
);

export const ChatBubbleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M17.3742 9.99967C17.374 5.92672 14.0717 2.625 9.9987 2.625C5.92586 2.62518 2.6242 5.92683 2.62402 9.99967C2.62402 14.0727 5.92575 17.375 9.9987 17.3752C11.3111 17.3752 12.5424 17.0325 13.6087 16.4328L13.717 16.3848C13.8289 16.3474 13.95 16.3428 14.0661 16.3717L17.2497 17.1668L16.7004 13.32C16.6838 13.2042 16.7003 13.086 16.7476 12.979C17.15 12.0688 17.3742 11.061 17.3742 9.99967ZM10.4992 10.3748C10.8442 10.3749 11.1241 10.6548 11.1242 10.9998C11.1242 11.345 10.8443 11.6247 10.4992 11.6248H6.99902C6.65385 11.6248 6.37402 11.345 6.37402 10.9998C6.37411 10.6547 6.6539 10.3748 6.99902 10.3748H10.4992ZM12.9992 6.375C13.3443 6.37509 13.6242 6.65488 13.6242 7C13.6242 7.34512 13.3443 7.62491 12.9992 7.625H6.99902C6.65385 7.625 6.37402 7.34518 6.37402 7C6.37402 6.65482 6.65385 6.375 6.99902 6.375H12.9992ZM18.6242 9.99967C18.6242 11.1722 18.3866 12.2904 17.9618 13.311L18.6193 17.9106C18.6487 18.1166 18.5736 18.3238 18.4191 18.4632C18.2646 18.6026 18.0505 18.6561 17.8486 18.6056L13.9985 17.6429C12.8025 18.27 11.4411 18.6252 9.9987 18.6252C5.23539 18.625 1.37402 14.763 1.37402 9.99967C1.3742 5.23648 5.2355 1.37518 9.9987 1.375C14.762 1.375 18.624 5.23637 18.6242 9.99967Z"
      fill="#010203"
    />
  </svg>
);

export const PdfContainer = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  backgroundColor: '#F7F8FC',
  overflow: 'hidden',

  '--rpv-core__page-layer-box-shadow': 'none',

  '& .rpv-core__viewer': {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: 'transparent !important',
  },

  '& .rpv-core__inner-pages': {
    backgroundColor: '#F7F8FC !important',
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    padding: '1.5rem 1rem !important',
    scrollbarWidth: 'none' as const,
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  },

  '& .rpv-core__inner-page': {
    boxShadow: '0 2px 8px rgba(0,0,0,0.15) !important',
    border: 'none !important',
    marginBottom: '1rem !important',
  },

  '& .rpv-core__page-layer': {
    boxShadow: 'none !important',
    border: 'none !important',
  },
}));

export const RotateCustomIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M3.95842 9.99992C3.95842 6.64493 6.5911 3.95825 9.79826 3.95825C11.91 3.95832 13.7666 5.12044 14.7942 6.87492H13.4343C13.0892 6.87497 12.8093 7.15477 12.8093 7.49992C12.8093 7.84506 13.0892 8.12487 13.4343 8.12492H16.6667C17.0119 8.12492 17.2917 7.8451 17.2917 7.49992V4.16659C17.2917 3.82141 17.0119 3.54159 16.6667 3.54159C16.3216 3.54159 16.0417 3.82141 16.0417 4.16659V6.87492H15.984C16.0422 6.7109 16.0351 6.52432 15.9433 6.3606C14.7228 4.18484 12.4327 2.70833 9.79826 2.70825C5.86477 2.70825 2.70842 5.99111 2.70842 9.99992C2.70842 14.0087 5.86477 17.2916 9.79826 17.2916C12.9534 17.2915 15.6113 15.1757 16.5365 12.2729C16.6412 11.9441 16.4592 11.5923 16.1305 11.4875C15.8016 11.3829 15.4499 11.5648 15.3451 11.8936C14.5737 14.3138 12.3725 16.0415 9.79826 16.0416C6.5911 16.0416 3.95842 13.3549 3.95842 9.99992Z"
      fill="black"
    />
  </svg>
);
